import script from "./CategoryIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryIcon.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryIcon.vue?vue&type=style&index=0&id=27f706a1&scoped=true&lang=css"

import exportComponent from "../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27f706a1"]])

export default __exports__